import { AllowSaveToCloud } from '@shared/constants'
import { getRequest, putRequest, postRequest } from './request'
import { DOMAIN } from './constant'

export const queryMyProfile = () => {
  return getRequest(`${DOMAIN}/api/user/me`)
}

export const updateMyProfile = (data: {
  avatar?: string
  nickname?: string
  allowSaveToCloud?: AllowSaveToCloud
}) => {
  return putRequest(`${DOMAIN}/api/user/me`, data)
}

export const changePassword = (oldPassword: string, newPassword: string) => {
  return putRequest(`${DOMAIN}/api/user/change-password`, {
    oldPassword,
    newPassword
  })
}

export const setPassword = (password: string) => {
  return putRequest(`${DOMAIN}/api/user/set-password`, {
    password
  })
}

export const postExportDesign = (metadata?: Record<string, any>) => {
  return postRequest(`${DOMAIN}/api/user/events/export`, {
    metadata
  })
}
